import { getLang } from 'utils/literals';

import { LEADS_LITERALS } from '../literals';

/**
 * Literals passed into lead-pop. All user-facing keys resolve through web4 `getLiteral`.
 * @param {(key: string, ...args: unknown[]) => string} getLiteral
 * @param {string} [lang] Web4 language code (`getLang()`).
 */
export function buildLeadPopLiterals(getLiteral, lang = getLang()) {
    void lang;
    const lit = (specKey) => getLiteral(LEADS_LITERALS[specKey]);

    return {
        'hud.score': lit('gameHudScore'),
        'hud.time': lit('gameHudTime'),
        'hud.lives': lit('gameHudLives'),
        'hud.livesAria': lit('gameHudLivesAria'),
        'hud.soundOn': lit('gameHudSoundOn'),
        'hud.soundOff': lit('gameHudSoundOff'),
        'hud.soundToggle': lit('gameHudSoundToggle'),
        'hud.good': lit('gameHudGood'),
        'game.title': lit('gameTitle'),
        'game.subtitle': lit('enhancementProgress'),
        'game.intro.title': lit('gameIntroTitle'),
        'game.intro.subtitle': lit('gameIntroSubtitle'),
        'game.intro.go': lit('gameIntroGo'),
        'game.paused': lit('gamePaused'),
        'game.soundHint': lit('gameSoundHint'),
        'result.finished': lit('enhancementComplete'),
        'result.died': lit('gameResultDied'),
        'result.skipped': lit('gameResultSkipped'),
        'result.score': lit('gameResultScore'),
        'result.goodHits': lit('gameResultGoodHits'),
        'result.badHits': lit('gameResultBadHits'),
        'result.copy': lit('gameResultCopy'),
        'result.copying': lit('gameResultCopying'),
        'result.copiedImage': lit('gameResultCopiedImage'),
        'result.copiedText': lit('gameResultCopiedText'),
        'result.copyError': lit('gameResultCopyError'),
        'result.restart': lit('gameResultRestart'),
        'result.viewProspectingResults': lit('viewEnhancementResults'),
        'items.hot': lit('gameItemHot'),
        'items.bonusName': lit('gameItemBonusName'),
        'items.bonus': lit('gameItemBonus'),
        'activities.phoneCall': lit('gameActivityPhoneCall'),
        'activities.checkIn': lit('gameActivityCheckIn'),
        'activities.videoCheckIn': lit('gameActivityVideoCheckIn'),
        'activities.fastCheckIn': lit('gameActivityFastCheckIn'),
        'activities.email': lit('gameActivityEmail'),
        'activities.videoCall': lit('gameActivityVideoCall'),
        'activities.whatsapp': lit('gameActivityWhatsapp'),
        'badItems.spam': lit('gameBadSpam'),
        'badItems.spam.subtitle': lit('gameBadSpamSubtitle'),
        'badItems.urgentMeeting': lit('gameBadUrgentMeeting'),
        'badItems.urgentMeeting.subtitle': lit('gameBadUrgentMeetingSubtitle'),
        'badItems.ghostClient': lit('gameBadGhostClient'),
        'badItems.ghostClient.subtitle': lit('gameBadGhostClientSubtitle'),
        'badItems.infiniteExcel': lit('gameBadInfiniteExcel'),
        'badItems.infiniteExcel.subtitle': lit('gameBadInfiniteExcelSubtitle'),
        'badItems.massCc': lit('gameBadMassCc'),
        'badItems.massCc.subtitle': lit('gameBadMassCcSubtitle'),
        'badItems.surpriseMeeting': lit('gameBadSurpriseMeeting'),
        'badItems.surpriseMeeting.subtitle': lit('gameBadSurpriseMeetingSubtitle'),
        'badItems.zombieLead': lit('gameBadZombieLead'),
        'badItems.zombieLead.subtitle': lit('gameBadZombieLeadSubtitle'),
        'badItems.coldCoffee': lit('gameBadColdCoffee'),
        'badItems.coldCoffee.subtitle': lit('gameBadColdCoffeeSubtitle'),
        'badItems.duplicate': lit('gameBadDuplicate'),
        'badItems.duplicate.subtitle': lit('gameBadDuplicateSubtitle'),
    };
}
